<template>
<span class="loader-spinner">
	<i class="fa fa-spinner fa-spin fa-fw"
		:class="size ? `fa-${size}` : ''"
		:fixed-width="!size"
		spin
		v-show="showSpinner"
		:size="size ? size : null"
		:style="color ? `color: ${color};` : null"
	></i>

	<span v-show="!showSpinner">
		{{ text }}
	</span>
</span>
</template>
<script>
export default {
	name: 'loader-button',
	data: () => ({}),
	props: {
		showSpinner: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: ''
		},
		size: {
			type: String,
		},
		color: {
			type: String,
		}
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// LoaderSpinner.vue?4f0a3b65